<template>
<v-container fluid fill-height grid-list-md>
    <v-layout column>
        <v-progress-linear :indeterminate="true" v-if="loading" color="primary"></v-progress-linear>
        <v-alert class="ma-1" :type="messageType" :value="showMessage">{{ alertMessage }}</v-alert>
        <v-flex v-if="!mapFullscreen">
            <v-layout row wrap>
                <v-flex xs12 sm6 md6 lg6 xl6>
                    <v-card dark color="primary" flat>
                        <v-card-title>
                            <h3 class="mr-1">Alerts</h3><span>(Showing top alerts per category)</span>
                            <v-spacer />
                            <v-icon>notifications_active</v-icon>
                        </v-card-title>
                    </v-card>
                    <alert-list :alerts="alerts" :categoryTotals="categoryTotals" :showMore="true"></alert-list>
                    <v-alert class="ma-0" type="info" :value="categoryTotals == 0">No data available</v-alert>
                </v-flex>
                <v-flex xs12 sm6 md6 lg6 xl6>
                    <div style="background-color:white">
                        <v-card dark color="primary" flat>
                            <v-card-title>
                                <h3>Unprocessed Pick Records</h3>
                                <v-spacer />
                                <v-icon>spa</v-icon>
                            </v-card-title>
                        </v-card>
                        <unprocessed-pick-record-list v-if="unprocessedPickRecords.length > 0" :unprocessedPickRecords="unprocessedPickRecords"></unprocessed-pick-record-list>
                        <v-alert class="ma-0" type="info" :value="unprocessedPickRecords.length == 0">No data available</v-alert>
                    </div>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-card dark color="primary" flat>
                        <v-card-title>
                            <h3 class="mr-1">Active Crews Today</h3>
                            <v-spacer />
                            <v-icon>directions_run</v-icon>
                        </v-card-title>
                    </v-card>
                    <plant-summary :plantSummary="plantSummary"></plant-summary>
                    <v-alert class="ma-0" type="info" :value="plantSummary.length == 0">No data available</v-alert>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex v-if="DisplayPlantMap" xs12 sm12 md12 lg12 xl12>
            <Map id="mapContainer" />
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import moment from "moment";

import Map from './../components/maps/PlantMap'
import AlertList from "./../components/alerts/AlertList.vue"
import UnprocessedPickRecordList from "./../components/pickRecords/UnprocessedPickRecordList.vue"
import PlantSummary from "./../components/plants/PlantSummary.vue"

import alertApi from './../api/alertApi';
import pickRecordApi from './../api/pickRecordsApi';
import plantApi from './../api/plantApi';

import store from "./../store";

export default {
    components: {
        Map,
        AlertList,
        UnprocessedPickRecordList,
        PlantSummary
    },
    data() {
        return {
            alerts: [],
            categoryTotals: [],
            unprocessedPickRecords: [],
            plantSummary: [],
            DisplayPlantMap: false,
            maxAlerts: 10,
            loading: false,
            showMessage: false,
            messageType: "warning",
            alertMessage: "",
            mapFullscreen: false
        }
    },
    methods: {
        resizeMap(fullscreen) {
            this.mapFullscreen = fullscreen
        }
    },
    async mounted() {
        // Allow any other component to emit this event on the global event bus.
        this.$root.$on('resizeMap', this.resizeMap);

        try {
            this.loading = true;

            this.categoryTotals = await alertApi.getCategories();
            this.alerts = await alertApi.getAlerts(this.maxAlerts);
            this.unprocessedPickRecords = await pickRecordApi.getUnproccessedPickRecords();
            this.plantSummary = await plantApi.getPlantSummary(moment().format('YYYY-MM-DD'));
            this.DisplayPlantMap = store.getters["UserStore/isAuthorised"]({accessRights:['View Plant Data']});            

        } catch (err) {
            if (err.message == 'Network Error') {
                console.log('There was a network error.');

                this.alertMessage = "You are offline"
                this.messageType = "warning"
                this.showMessage = true;
            } else {
                this.alertMessage = "An error has occured"
                this.messageType = "error"
                this.showMessage = true;

                throw err;
            }
        } finally {
            this.loading = false;
        }
    }
}
</script>

<style scoped>
</style>
